import { useSelector } from 'react-redux';
import FinancingHelper from './financing_helper';
import { useEffect, useState } from 'react';

const loan = {
  amount_financed: 'Financing Amount',
  docs_application_complete: 'Application Complete!',
  loan_details: 'Loan Details',
  breadcrumb_eligibility: 'Eligibility',
  retrieving_eligibility_results: 'Retrieving Eligibility Results',
  retrieving_eligibility_continue_text: 'View Results',
  generic_transaction_type: 'loan',
};
const cash = {
  ...loan,
  amount_financed: 'Project Cost',
  docs_application_complete: 'Project Complete!',
  loan_details: 'Project Details',
  breadcrumb_eligibility: 'Project Details',
  retrieving_eligibility_results: 'Retrieving Project Details',
  retrieving_eligibility_continue_text: 'Continue',
  generic_transaction_type: 'cost',
};
const lease = {
  ...loan,
};
const hvac = {
  ...loan,
};
const battery = {
  ...loan,
};
const PRODUCT_LANG = { loan, cash, lease, hvac, battery };

/**
 * Pass in either productType or financingMethod productType takes priority.
 * @returns String
 */
const getProductText = ({ productType, financingMethod, text_sku, variables = {} }) => {
  const pt = productType ?? FinancingHelper.getProductType(financingMethod).toLowerCase();
  const template = PRODUCT_LANG[pt]?.[text_sku] ?? text_sku;

  return template.replace(/\\{\{(\w+)\}\}/g, (_, key) => variables[key] ?? '');
};

export const useProductText = (text_sku, variables = {}) => {
  const financingMethod = useSelector((redux) => redux.financingMethod);
  const [val, setVal] = useState(text_sku);

  useEffect(
    () => setVal(getProductText({ text_sku, financingMethod, variables })),
    [text_sku, financingMethod, variables]
  );

  return val;
};

const GenericProductText = ({ text_sku, ...props }) => {
  const financingMethod = useSelector((redux) => redux.financingMethod);
  const skuText = getProductText({ text_sku, financingMethod });

  return skuText && <span {...props}>{skuText}</span>;
};

GenericProductText.getProductText = getProductText;

export default GenericProductText;
